import {Link, Navigate, useNavigate} from "react-router-dom";
import {userRoleList} from "../../../utils/constants";
import Loader from "../../components/shared/Loader";
import {MenuList, MenuListClient} from "./Menu";
import MenuItem from "./MenuItem";
import {useMe} from "../../../hooks/useGetUser";
import MobileMenuItem from "./MobileMenuItem";
import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoProfile from "../../../images/profileImage.png";
import {useState} from "react";
import {Logout} from "../../../store/actions/AuthActions";
import {useDispatch} from "react-redux";

const SideNav = ({toggleMenu}) => {
  const {data, isLoading, isError} = useMe();
  const [openProfile, setOpenProfile] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function onLogout() {
    dispatch(Logout(navigate));
    // window.location.reload();
  }
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <Navigate to={"/login"} replace />;
  }
  return (
    <div
      className={`w-full  lg:hidden bg-white transition-all duration-300 ease-in-out   ${
        toggleMenu ? "translate-x-0 h-screen" : "-translate-x-full h-0 "
      }`}
    >
      <div className=" w-full  flex flex-col gap-3 justify-start items-start p-4 ">
        <div className="w-full flex flex-col gap-2 justify-start items-start border-b solid border-[#e7e7e7]">
          <div className="flex items-center justify-start gap-3  w-full pb-3">
            <div className="relative min-w-14 w-14 ">
              {/* <div className="bg-[#FFC107] w-[50px] flex justify-center gap-[2px] items-center leading-none  text-white text-[9px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
              <span>{Number(data?.avgRating).toFixed(2)}</span>
              <StarIcon className="fill-white stroke-none w-3 h-3" />
            </div> */}

              <ImageComponent
                src={buildImageUrl(data?.imageUri)}
                // style={{boxShadow: "3px 3px 8px 0px rgba(0,0,0,0.35)"}}
                alt=""
                className=" w-14 aspect-square min-w-11 rounded-full object-cover "
                fallback={
                  <img
                    src={NoProfile}
                    alt=""
                    className=" w-14 aspect-square min-w-11 rounded-full object-cover"
                  />
                }
              />
            </div>
            <div className="flex flex-col justify-center items-start flex-grow">
              <span className="text-[#19295C] font-bold text-sm capitalize">
                {data?.lastName + " " + data?.firstName}
              </span>

              <div className=" text-primary font-semibold text-sm flex items-center gap-3 text-nowrap mr-[50px]">
                {data.selectedRole === userRoleList.TECHNICIAN
                  ? "Prestataire"
                  : "Client"}
              </div>
            </div>
            <div
              onClick={() => {
                setOpenProfile((prev) => !prev);
              }}
              className=" rounded-full w-6 aspect-square text-xs border border-white border-solid flex justify-center
                items-center bg-[#dadada] text-[#3D4465]"
            >
              <i className="fi fi-rr-angle-small-down flex items-center"></i>
            </div>
          </div>
          <div
            className={`flex flex-col justify-start items-start gap-4  transition-all duration-300 ease-in-out overflow-hidden  ${
              openProfile ? "h-fit mb-4 " : "!h-0 "
            }  `}
          >
            <Link to="/mon-profil" className=" ">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-user flex items-center"></i>
                </span>
                <span className=" text-[#3D4465] ">Mon profil </span>
              </div>
            </Link>
            <Link to="/mon-compte" className=" ">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-user-gear flex items-center"></i>
                </span>
                <span className=" text-[#3D4465] ">Mon compte </span>
              </div>
            </Link>
            <Link to="/reclamations" className=" ">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-megaphone-sound-waves flex items-center"></i>
                </span>
                <span className=" text-[#3D4465] ">Réclamations </span>
              </div>
            </Link>
            <Link to="/changer-mot-de-passe" className="">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-lock flex items-center"></i>
                </span>
                <span className=" text-[#3D4465]">Changer mot de passe</span>
              </div>
            </Link>
            {data.selectedRole === userRoleList.TECHNICIAN && (
              <Link to="/paiement" className="">
                <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                  <span className="text-xl">
                    <i className="fi fi-rr-credit-card flex items-center"></i>
                  </span>
                  <span className=" text-[#3D4465]">Paiement</span>
                </div>
              </Link>
            )}
            <Link to="/factures" className="">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-file-invoice flex items-center"></i>
                </span>
                <span className=" text-[#3D4465]">Mes factures</span>
              </div>
            </Link>
            <Link to="/parametres-du-compte" className="">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-settings flex items-center"></i>
                </span>
                <span className=" text-[#3D4465]">Paramètres du compte</span>
              </div>
            </Link>
            <Link to="/conditions-generales" className="">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-memo-circle-check flex items-center"></i>
                </span>
                <span className=" text-[#3D4465]">Conditions générales</span>
              </div>
            </Link>
            <Link to="/politique-de-confidentialite" className="">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-lock flex items-center"></i>
                </span>
                <span className="text-[#3D4465]">
                  Politique de confidentialité
                </span>
              </div>
            </Link>
            <Link to="/centre-aide" className="">
              <div className="w-full flex items-center justify-start gap-2 text-[#1A64B9]">
                <span className="text-xl">
                  <i className="fi fi-rr-life-ring flex items-center"></i>
                </span>
                <span className=" text-[#3D4465]">Aide</span>
              </div>
            </Link>
            <div
              className="w-full flex items-center justify-start gap-2 text-[#FF6600]"
              onClick={onLogout}
            >
              <span className="text-xl">
                <i className="fi fi-rr-sign-out-alt flex items-center"></i>
              </span>
              <span className=" text-[#3D4465]">Déconnexion</span>
            </div>
          </div>
        </div>
        {data.selectedRole === userRoleList.TECHNICIAN
          ? !!MenuList.length &&
            MenuList.map((item) => (
              <MobileMenuItem key={item?.title} item={item} />
            ))
          : !!MenuListClient.length &&
            MenuListClient.map((item) => (
              <MobileMenuItem key={item?.title} item={item} />
            ))}
      </div>
    </div>
  );
};
export default SideNav;
